<p class="helper mb-2">
  {{ text }}
</p>
